import { Exercise } from '../../../entities/exercise/exercise';
import { IExerciseRepository } from '../interfaces/iexercise-repository';

const stubData: string = `[
{"name":"Ab Crunch","level":["Beginner","Intermediate"],"bagContact":true,"cardioOrResistance":"Cardio",
"bodyGroups":["Abdomen"],"compatibleZones":[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],"similarityCode":[1]},
{"name":"Burbee","level":["Expert"],"bagContact":true,"cardioOrResistance":"Cardio",
"bodyGroups":["Abdomen"],"compatibleZones":[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],"similarityCode":[2]},
{"name":"Cleans","level":["Beginner"],"bagContact":true,"cardioOrResistance":"Cardio",
"bodyGroups":["Abdomen"],"compatibleZones":[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],"similarityCode":[3]},
{"name":"Deadlift","level":["Beginner"],"bagContact":true,"cardioOrResistance":"Resistance",
"bodyGroups":["Abdomen"],"compatibleZones":[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],"similarityCode":[5]},
{"name":"Elbow Plan","level":["Intermediate"],"bagContact":true,"cardioOrResistance":"Cardio",
"bodyGroups":["Abdomen"],"compatibleZones":[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],"similarityCode":[6]},
{"name":"Flys","level":["Expert"],"bagContact":true,"cardioOrResistance":"Cardio",
"bodyGroups":["Abdomen"],"compatibleZones":[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],"similarityCode":[7]},
{"name":"Goblet Squat","level":["Beginner"],"bagContact":true,"cardioOrResistance":"Cardio",
"bodyGroups":["Abdomen"],"compatibleZones":[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],"similarityCode":[8]},
{"name":"Hammer Curl","level":["Beginner"],"bagContact":true,"cardioOrResistance":"Resistance",
"bodyGroups":["Abdomen"],"compatibleZones":[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],"similarityCode":[9]},
{"name":"Incline Curl","level":["Expert"],"bagContact":true,"cardioOrResistance":"Cardio",
"bodyGroups":["Abdomen"],"compatibleZones":[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],"similarityCode":[10]},
{"name":"Jab Bag","level":["Intermediate"],"bagContact":true,"cardioOrResistance":"Cardio",
"bodyGroups":["Abdomen"],"compatibleZones":[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],"similarityCode":[11]},
{"name":"Warmup1","level":["Intermediate"],"bagContact":true,"cardioOrResistance":"Cardio",
"bodyGroups":["Abdomen"],"compatibleZones":[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],"similarityCode":[11],
"exerciseFormats": ["WUModBurn"]},
{"name":"Warmdown1","level":["Intermediate"],"bagContact":true,"cardioOrResistance":"Cardio",
"bodyGroups":["Abdomen"],"compatibleZones":[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],"similarityCode":[11],
"exerciseFormats": ["Warmdown30Hybrid"]}]
`;

export class JsonExerciseRepository implements IExerciseRepository {
  public add(exercise: Exercise): Promise<void> {
    throw new Error('Method not implemented.');
  }

  public async getAll(): Promise<Exercise[]> {
    const exercises: Exercise[] = JSON.parse(stubData);
    return exercises;
  }

  public async get(id: string): Promise<Exercise | undefined> {
    const exercises = await this.getAll();
    return new Promise<Exercise | undefined>((resolve) => {
      resolve(exercises.find((e: Exercise) => e.name === id));
    });
  }
}
